<ion-header>
  <ion-toolbar>
    <ion-title>Console Logs</ion-title>
    <ion-buttons slot="start">
      <ion-button class="headButtons" (click)="clearLogs()">Clear</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="headButtons" (click)="close()" [strong]="true">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>

  <div class="log-container">
    <div class="log-empty" *ngIf="logs.length === 0">
      No logs captured
    </div>

    <div class="log-entry" *ngFor="let log of logs; let i = index; trackBy: trackByIndex" [ngClass]="getTypeClass(log.type)">
      <span class="log-type">[{{ log.type }}]</span>
      <ng-container *ngFor="let arg of log.args; let j = index; trackBy: trackByIndex">
        <span
          *ngIf="!isExpandable(arg)"
          class="log-arg">{{ arg.display }}</span>
        <span
          *ngIf="isExpandable(arg)"
          class="log-arg expandable"
          (click)="toggleExpand(i, j)">
          <ion-icon [name]="isExpanded(i, j) ? 'chevron-down' : 'chevron-forward'"></ion-icon>
          {{ arg.display }}
        </span>
        <pre *ngIf="isExpandable(arg) && isExpanded(i, j)" class="log-expanded">{{ formatJson(arg.value) }}</pre>
      </ng-container>
    </div>
  </div>

</ion-content>